module.exports = __webpack_public_path__ + "img/32.4d2c4763.png";